import { useEffect } from 'react';
import { Project } from '@bechtel/types';
import { find, get, toLower } from 'lodash';
import { useProjectCommodityTypesById } from '@bechtel/client-weld-common';
import { useAppUser } from '@bechtel/client-common';

export function useWeldTypeId() {
  const { user } = useAppUser();
  const [getProject, { called: projectCalled, data: projectData }] = useProjectCommodityTypesById();
  const projectDetailArr: Project[] = get(projectData, 'projectsByIds', []);
  const projectDetail = projectDetailArr.length > 0 ? projectDetailArr[0] : null;
  const weldTypeId = find(projectDetail?.projectConfiguration?.projectCommodityTypes, (item) => {
    return toLower(item?.name) === 'weld';
  })?.id;
  useEffect(() => {
    if (!user || !user.project || projectCalled) return;
    getProject({
      variables: {
        ids: [user?.project?.id],
      },
    });
  }, [user]);

  return {
    weldTypeId,
  };
}
